/**
 * BEKATEQ Cart Utility
 * Central ATC (Add to Cart) handler with cart-icon-bubble update + button feedback.
 * Used by main-product-datenblatt.liquid and product-cross-sell.liquid.
 *
 * Usage:
 *   BekateqCart.add(items, button)
 *     items  – array of { id: variantId, quantity: n }
 *     button – the clicked button element (for visual feedback)
 *
 *   BekateqCart.refreshBadge()
 *     manually refresh the cart badge from /cart.js
 */
(function () {
  'use strict';

  var SUCCESS_DURATION = 2000;

  /* Build sections string: always include cart-icon-bubble + cart-drawer section */
  var SECTIONS = (function () {
    var parts = ['cart-icon-bubble'];
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      var shopifySection = drawerEl.closest('.shopify-section');
      if (shopifySection) {
        parts.push(shopifySection.id.replace('shopify-section-', ''));
      }
    }
    return parts.join(',');
  })();

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  function updateBubble(sections) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections && sections['cart-icon-bubble']) {
      bubble.innerHTML = sections['cart-icon-bubble'];
    }
  }

  function refreshBadge() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header__cart-count-number').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      })
      .catch(function () {});
  }

  function setButtonState(btn, state) {
    if (!btn) return;
    btn.classList.remove('pdp-buy-btn--loading', 'pdp-buy-btn--success',
      'cs-card__atc--success', 'cs-card__atc--error');
    if (state === 'loading') {
      btn.classList.add('pdp-buy-btn--loading');
      btn.disabled = true;
    } else if (state === 'success') {
      btn.classList.add('pdp-buy-btn--success', 'cs-card__atc--success');
      btn.disabled = true;
    } else if (state === 'error') {
      btn.classList.add('cs-card__atc--error');
    }
  }

  /**
   * Add items to cart with visual feedback.
   * @param {Array} items – [{ id, quantity }]
   * @param {HTMLElement} btn – the ATC button (optional)
   * @param {Object} opts – { successText, errorText, originalText } (optional)
   * @returns {Promise}
   */
  function add(items, btn, opts) {
    opts = opts || {};

    // Wenn der Button intern eigene Spans für loading/success-States hat (z.B.
    // .pdp-buy-btn mit .pdp-buy-btn__text / __loading-text / __success-text),
    // gibt's nichts zu sichern — die CSS-Klassen schalten die richtigen Spans
    // sichtbar/unsichtbar. Nur für simple Text-only Buttons (z.B. Cross-Sell-Karten)
    // sichern wir den originalen Inhalt als HTML-Snapshot.
    var hasInternalStates = btn && (
      btn.querySelector('.pdp-buy-btn__loading-text') ||
      btn.querySelector('.pdp-buy-btn__success-text') ||
      btn.querySelector('[data-buy-text]')
    );
    var originalHtml = opts.originalText ||
      (btn && !hasInternalStates ? btn.innerHTML : null);

    setButtonState(btn, 'loading');

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: items,
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function (data) {
        /* Update cart icon from sections response */
        updateBubble(data.sections);
        refreshBadge();

        /* Update and open cart drawer (matches product-form.js behavior) */
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && data.sections) {
          setTimeout(function () {
            cartDrawer.renderContents(
              data,
              typeof theme !== 'undefined' && theme.settings && theme.settings.afterAtc === 'drawer'
            );
          }, 300);
        }

        /* Button success state: nur Klassen togglen — der Button hat eigene Spans
           die per CSS sichtbar werden. Nur fuer simple Text-Buttons (kein
           hasInternalStates) wird Text geupdated. */
        setButtonState(btn, 'success');
        if (btn && !hasInternalStates && opts.successText) {
          btn.textContent = opts.successText;
        }

        setTimeout(function () {
          setButtonState(btn, null);
          if (btn) {
            btn.disabled = false;
            if (!hasInternalStates && originalHtml !== null) {
              btn.innerHTML = originalHtml;
            }
          }
        }, SUCCESS_DURATION);

        return data;
      })
      .catch(function (err) {
        console.error('BekateqCart.add error:', err);
        setButtonState(btn, 'error');
        if (btn && !hasInternalStates) {
          btn.textContent = opts.errorText || 'Fehler';
        }
        setTimeout(function () {
          setButtonState(btn, null);
          if (btn) {
            btn.disabled = false;
            if (!hasInternalStates && originalHtml !== null) {
              btn.innerHTML = originalHtml;
            }
          }
        }, SUCCESS_DURATION);
        throw err;
      });
  }

  window.BekateqCart = {
    add: add,
    refreshBadge: refreshBadge,
    formatMoney: formatMoney
  };
})();
